import { Skeleton } from '../components/ui/skeleton';

export const ProductSkeleton = () => {
    return (
        <div className="product-card" data-testid="product-skeleton">
            <Skeleton className="w-full aspect-square" />
            <div className="product-card-content space-y-3">
                <Skeleton className="h-5 w-3/4" />
                <Skeleton className="h-4 w-full" />
                <div className="flex items-center justify-between pt-2">
                    <Skeleton className="h-6 w-20" />
                    <Skeleton className="h-10 w-24 rounded-lg" />
                </div>
            </div>
        </div>
    );
};

export const ProductGridSkeleton = ({ count = 8 }) => {
    return (
        <div className="product-grid">
            {Array.from({ length: count }).map((_, i) => (
                <ProductSkeleton key={`skeleton-${i}`} />
            ))}
        </div>
    );
};
